import axios from "axios";
import beveatApiResourceOwner from "../../api/resource_owner_beveat_api.js";
import beveatApiStaging from "../../api/staging_beveat_api.js";
import beveatApiSandbox from "../../api/sandbox_beveat_api.js";
import beveatApiProduction from "../../api/production_beveat_api.js";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { DEVELOPER_PROJ_STATUS } from "../../constants/developer_proj_status.jsx";
import { doublewriteConfig } from "../../../config.js";
import { commonConfigs, urls } from "../../../config.js";
import { getUser } from "../../services/local_service.js";
import { INVOICE_PLAN_SYSCODE, InvoicePlanSyscodeString } from "../../constants/invoice_plan_syscode.jsx";
import CreateCertificateDetailsModal from "../plans/components/create_certificate_details_modal.jsx";
import { INVOICE_SYSCODE } from "../../constants/invoice_syscode.jsx";

const DeveloperProjectCard = ({ data, invoicePlanSyscode }) => {
  const [isOpen, setOpen] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const accountId = getUser()?.account_id;
  const devProjTableSyscode = invoicePlanSyscode;
  const access = data.access.filter((project) => project.project_name !== "beveatshop");
  const invPlanId = access[0].org_invoice_plan_id;
  const certificateDisableCheck = access[0].invoice_syscode == INVOICE_SYSCODE.Project;

  const navigate = useNavigate();
  async function getDeveloperCourse(planId, projId) {
    const getDeveloperCourseUrl =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.getDeveloperCourses(accountId, planId, 0);
    await beveatApiResourceOwner
      .get(getDeveloperCourseUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then(async (res) => {
        // console.log(res.data.result.data);
        if (Object.keys(res.data.result.data).length !== 0) {
        } else { // Project expired
          await updateDeveloperProj(projId);
          await updateDoublewriteDevProj(projId);
        }
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  }

  async function updateDoublewriteDevProj(projId) {
    const { url, headers } = doublewriteConfig(process.env.REACT_APP_ENV);
    const doublewriteUrl =
      url + commonConfigs.apiUrls.UpdateDeveloperProject(projId, devProjTableSyscode);
    const body = {
      developer_proj_status: DEVELOPER_PROJ_STATUS.Expired,
    };
    try {
      let apiInstance;

      if (url === process.env.REACT_APP_BASE_OPENAPIPAAS_STAGING_URL) {
        apiInstance = beveatApiStaging;
      } else if (url === process.env.REACT_APP_BASE_OPENAPIPAAS_SANDBOX_URL) {
        apiInstance = beveatApiSandbox;
      } else if (url === process.env.REACT_APP_BASE_OPENAPIPAAS_PRODUCTION_URL) {
        apiInstance = beveatApiProduction;
      } else {
        apiInstance = axios;
      }

      await apiInstance.put(doublewriteUrl, body, { headers: headers });
    } catch (error) {
      console.error("Error updating doublewrite project:", error);
    }
  }

  async function updateDeveloperProj(projId) {
    const updateProjUrl =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.UpdateDeveloperProject(projId, devProjTableSyscode);
    const body = {
      developer_proj_status: DEVELOPER_PROJ_STATUS.Expired,
    };
    try {
      await beveatApiResourceOwner.put(updateProjUrl, body, {
        headers: commonConfigs.resourceOwnerApiHeader,
      });
    } catch (error) {
      console.error("Error updating doublewrite project:", error);
    }
  }

  useEffect(() => {
    getDeveloperCertificates();
    // if (invoicePlanSyscode === INVOICE_PLAN_SYSCODE.Staging) {
    getDeveloperCourse(invPlanId, data.developer_proj_id).catch((err) => {
      console.log("err for getting developer courses: " + err);
    });
    // }
  }, [])

  const renderEnabledAPIs = () => {
    const projects = data.access
      .filter((project) => project.project_name !== "beveatshop")
      .map((project) => project.project_name);
    if (projects.length === 1) {
      return projects[0];
    } else {
      return projects.join(" | ");
    }
  };

  async function getDeveloperCertificates() {
    const getDeveloperCertificatesUrl =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.getAllDeveloperCertificates(accountId);
    const res = await beveatApiResourceOwner.get(getDeveloperCertificatesUrl, {
      headers: commonConfigs.resourceOwnerApiHeader,
    });
    setCertificates(res.data.result.data);
  }

  const onGetCertificateClick = () => {
    const certificate = certificates.find(
      (cert) =>
        cert.org_invoice_plan_id === invPlanId &&
        cert.developer_proj_id === data.developer_proj_id
    );
    if (certificate) {
      navigate("/certification", {
        state: {
          planName: access[0].invoice_plan ?? null,
          certificationPlanId: invPlanId,
          environment: InvoicePlanSyscodeString[invoicePlanSyscode],
          devProjId: data.developer_proj_id,
        },
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <div
      className="bg-white rounded-2xl"
      style={{
        // height: "inherit",
        // width: "100%",
        // minHeight: 0,
        // minWidth: 0,
        // boxShadow: "5px 10px #EBECF0",
        // marginTop: "20px",
        // borderWidth: "0.5px",
        // borderColor: "black",
        // borderStyle: "solid",
        // fontSize: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
        boxShadow: "5px 10px #EBECF0",
        marginTop: "20px",
        borderWidth: "0.5px",
        borderColor: "black",
        borderStyle: "solid",
        fontSize: "16px",
      }}
    >
      <div
        className="p-3"
        style={{
          // display: "grid",
          // gridTemplateAreas: `'text1 text1 text1' 'text2 text2 text2''text3 text3 text3''text4 text4 text4''button1 button1 button1'`,
          // gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          // gap: 4,
          // maxWidth: "inherit",
          // color: "black",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px",
          color: "black",
        }}
      >
        {/* header */}
        <div
          className="font-bold"
          style={{ gridArea: "text1", textAlign: "left" }}
        >
          {data.developer_proj_name}
        </div>

        {/* details */}
        <div className="pt-10" style={{ gridArea: "text2", textAlign: "left" }}>
          Status: {data.developer_proj_status_type}
        </div>

        <div className="pt-10" style={{ gridArea: "text3", textAlign: "left" }}>
          {renderEnabledAPIs()}
        </div>

        {/* last update */}
        <div
          className="pt-4 text-gray-700"
          style={{ gridArea: "text4", textAlign: "left" }}
        >
          Created on:
          &nbsp;
          {format(new Date(data.created_on), "dd MMM yyyy HH:mm")}
        </div>

        {/* buttons */}
        <div style={{ marginTop: "auto", display: "flex", justifyContent: "center", gap: "30px" }}>
          <Link
            to={`/projects/details`}
            state={{
              developerSsoId: data.developer_sso_id,
              developerProjId: data.developer_proj_id,
              invoicePlanSyscode: invoicePlanSyscode,
            }}
          >
            <button
              type="button"
              className="hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 py-2 px-12 rounded-full text-sm mt-4"
              style={{ textAlign: "center" }}
            >
              View More
            </button>
          </Link>
          <button
            type="button"
            className={`py-2 px-12 rounded-full text-sm mt-4 
              ${certificateDisableCheck ? 'bg-gray-300 text-gray-500 cursor-not-allowed outline-none'
                : 'hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500'}`
            }
            style={{ textAlign: "center" }}
            onClick={onGetCertificateClick}
            disabled={certificateDisableCheck}
          >
            Get Certificate
          </button>
        </div>
        {isOpen && (
          <CreateCertificateDetailsModal
            setOpenModal={setOpen}
            planName={access[0].invoice_plan ?? null}
            planId={invPlanId}
            devProjId={data.developer_proj_id}
            environment={InvoicePlanSyscodeString[invoicePlanSyscode]}
          />
        )}
      </div>
    </div>
  );
};

export default DeveloperProjectCard;
